import { useFormContext } from 'react-hook-form';
import { Content } from 'src/contexts/ContentContext';
import { Switch } from 'src/core/interim/Switch';
import { Stack } from 'src/core/ui';
import { mergeProps } from 'src/core/utils';
import { ContentId } from 'src/utils/constants/contentId';
import { Seating } from 'src/WebApiController';

import { BulkExternalIdInput } from '../UploadStringArtifacts/BulkStringArtifactInput';
import { ManualExternalIdEntry } from '../UploadStringArtifacts/ManualStringArtifactEntry';
import * as styles from './UploadExternalIds.css';
import { ExternalIdForm } from './UploadExternalIds.utils';

export type UploadExternalIdsBodyProps = {
  isReadOnly?: boolean;
  ticketCnt: number;
  seating: Seating;
  instructionContentId?: ContentId;
  className?: string;
};
export const UploadExternalIdsBody = ({
  className,
  isReadOnly,
  seating,
  ticketCnt,
  instructionContentId,
}: UploadExternalIdsBodyProps) => {
  const { watch, setValue } = useFormContext<ExternalIdForm>();

  const bulkUpload = watch('isBulkUpload');

  const inputProps = {
    readOnly: isReadOnly,
    seating,
    quantity: ticketCnt,
  };

  return (
    <div
      {...mergeProps(
        { className: styles.externalIdsContentWrapper },
        { className: className }
      )}
    >
      {!isReadOnly && (
        <Content id={instructionContentId ?? ContentId.EnterTicketIdsIns} />
      )}
      <Stack direction="row" gap="m" alignItems="center" justifyContent="end">
        <Content id={ContentId.BulkEntry} />
        <Switch
          checked={bulkUpload}
          onChange={() => setValue('isBulkUpload', !bulkUpload)}
          disabled={isReadOnly}
        />
      </Stack>
      {!bulkUpload ? (
        <ManualExternalIdEntry {...inputProps} />
      ) : (
        <BulkExternalIdInput
          {...inputProps}
          onPreview={() => setValue('isBulkUpload', !bulkUpload)}
        />
      )}
    </div>
  );
};
